// extracted by mini-css-extract-plugin
module.exports = {"downloadProgress":"download-progress--downloadProgress--3BVIA14"};